namespace $.$$ {

	$mol_style_define( $shm_ba_posts, {
		flexDirection: 'column',
		gap: '10px',
		userSelect: 'text',

		Title: {
			display: 'flex',
			alignItems: 'center',
			flexWrap: 'wrap',
			gap: '8px',
			font: {
				weight: 'bold',
				size: '20px',
			},
			margin: {
				bottom: '4px',
			},
		},
		Title_spacer: {
			flex: {
				grow: 1,
				shrink: 1,
				basis: '1rem',
			},
			minWidth: '1rem',
		},
		Page_tools: {
			display: 'flex',
			alignItems: 'center',
			flexWrap: 'wrap',
			gap: '24px',
			justifyContent: 'flex-end',
			margin: {
				left: 'auto',
			},
			font: {
				weight: 'normal',
				size: '13px',
			},
		},
		Page_tools_bottom: {
			display: 'flex',
			alignItems: 'center',
			flexWrap: 'wrap',
			gap: '24px',
			justifyContent: 'flex-end',
			margin: {
				top: '6px',
				left: 'auto',
			},
			font: {
				weight: 'normal',
				size: '13px',
			},
		},
		Page_size_label: {
			display: 'flex',
			flexDirection: 'row',
			alignItems: 'center',
			gap: '6px',
			minHeight: 0,
			whiteSpace: 'nowrap',
			Label: {
				padding: 0,
				minHeight: 0,
			},
		},
		Page_size_label_bottom: {
			display: 'flex',
			flexDirection: 'row',
			alignItems: 'center',
			gap: '6px',
			minHeight: 0,
			whiteSpace: 'nowrap',
			Label: {
				padding: 0,
				minHeight: 0,
			},
		},
		Page_size: {
			minHeight: 0,
			margin: {
				left: '-0.5rem',
			},
		},
		Page_size_bottom: {
			minHeight: 0,
			margin: {
				left: '-0.5rem',
			},
		},
		Page_numbers: {
			display: 'flex',
			alignItems: 'center',
			flexWrap: 'wrap',
			gap: '4px',
		},
		Page_numbers_bottom: {
			display: 'flex',
			alignItems: 'center',
			flexWrap: 'wrap',
			gap: '4px',
		},
		Page_number: {
			minWidth: '32px',
			minHeight: '32px',
			padding: {
				left: '8px',
				right: '8px',
				top: 0,
				bottom: 0,
			},
			justifyContent: 'center',
			font: {
				weight: 'normal',
				size: '13px',
			},
		},
		Page_number_bottom: {
			minWidth: '32px',
			minHeight: '32px',
			padding: {
				left: '8px',
				right: '8px',
				top: 0,
				bottom: 0,
			},
			justifyContent: 'center',
			font: {
				weight: 'normal',
				size: '13px',
			},
		},
		Page_gap: {
			alignItems: 'center',
			justifyContent: 'center',
			minWidth: '18px',
			minHeight: '32px',
			color: $mol_theme.shade,
			font: {
				weight: 'normal',
				size: '13px',
			},
		},
		Page_gap_bottom: {
			alignItems: 'center',
			justifyContent: 'center',
			minWidth: '18px',
			minHeight: '32px',
			color: $mol_theme.shade,
			font: {
				weight: 'normal',
				size: '13px',
			},
		},
		Page_info: {
			alignItems: 'center',
			minHeight: '32px',
			color: $mol_theme.shade,
			whiteSpace: 'nowrap',
		},
		Page_info_bottom: {
			alignItems: 'center',
			minHeight: '32px',
			color: $mol_theme.shade,
			whiteSpace: 'nowrap',
		},
		Sort_button: {
			minHeight: 0,
			padding: {
				left: '8px',
				right: '8px',
				top: '4px',
				bottom: '4px',
			},
			font: {
				weight: 'normal',
				size: '13px',
			},
		},
		More_sort: {
			minHeight: 0,
			font: {
				weight: 'normal',
				size: '13px',
			},
		},
	} )

	$mol_style_define( $shm_ba_posts_sort_button, {
		'@': {
			shm_ba_posts_sort_current: {
				true: {
					color: $mol_theme.current,
				},
			},
		},
	} )

	$mol_style_define( $shm_ba_posts_page_button, {
		'@': {
			shm_ba_posts_page_current: {
				true: {
					outline: '1px solid var(--mol_theme_current) !important',
					color: $mol_theme.current,
				},
			},
		},
	} )

}
